<template>
     <gz-auth-view-template :bc="false" contentClass="gz-auth-view-template__content_inner gz-form">
        <Shelter :single="true" :id="this.$route.params.id" slot="content"/>
     </gz-auth-view-template>
</template>

<script>
import Shelter from '@/components/custom/admin/forms/add-address/Shelter'

export default {
    name: 'SingleShelterView',

    components: {
        Shelter
    },
    data() {
        return {
            attributes: {},
            id: ''
        }
    },
    computed: {
        attributesComputed() {
            return this.attributes
        },
        idComputed() {
            return this.id
        }
    },
    mounted() {
        this.getShelter(this.$route.params.id)
    },
    methods: {
        getShelter(id) {
            this.$axios('property/' + id)
                .then(response => {
                    this.attributes = response.data.data
                    this.id = response.data.data.id
                }) 
                .catch(err => {
                    console.log('Ошибка загрузки данных о помещении: ', err)
                })
        }
    }
}
</script>